<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="11.903" height="11.904" viewBox="0 0 11.903 11.904">
		<path
			id="Path_20349"
			data-name="Path 20349"
			d="M11.453,6.35v-.5a.844.844,0,0,0-.844-.844.775.775,0,0,1-.548-1.322.844.844,0,0,0,0-1.193L9.71,2.143a.845.845,0,0,0-1.194,0,.774.774,0,0,1-1.322-.548A.845.845,0,0,0,6.349.75h-.5a.845.845,0,0,0-.844.844.775.775,0,0,1-1.322.548.845.845,0,0,0-1.194,0l-.351.352a.843.843,0,0,0,0,1.192.775.775,0,0,1-.548,1.322.845.845,0,0,0-.844.844v.5a.845.845,0,0,0,.844.844.775.775,0,0,1,.548,1.322.844.844,0,0,0,0,1.193l.351.352a.845.845,0,0,0,1.194,0,.774.774,0,0,1,1.322.548.845.845,0,0,0,.844.844h.5a.845.845,0,0,0,.844-.844.775.775,0,0,1,1.322-.548.844.844,0,0,0,1.193,0l.351-.351a.844.844,0,0,0,0-1.193A.774.774,0,0,1,10.608,7.2a.845.845,0,0,0,.844-.844Z"
			transform="translate(-0.15 -0.15)"
			fill="none"
			stroke="#5a677d"
			stroke-linecap="round"
			stroke-linejoin="round"
			stroke-width="1.2"
		/>
		<path
			id="Path_20350"
			data-name="Path 20350"
			d="M8.094,6.409A1.687,1.687,0,1,1,6.407,4.722h0A1.686,1.686,0,0,1,8.095,6.407v0Z"
			transform="translate(-0.456 -0.456)"
			fill="none"
			stroke="#5a677d"
			stroke-linecap="round"
			stroke-linejoin="round"
			stroke-width="1.2"
		/>
	</svg>
</template>

<script>
export default {
	name: 'ConfSvg',
};
</script>

<style scoped lang="scss"></style>
